import { RoundedBox, useTelemetry } from "@knowfully/ui.common";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  SxProps,
  Typography,
} from "@mui/material";
import { useStoreState } from "pullstate";
import { useEffect } from "react";
import errorStore from "stores/errorStore";
import { useIntl } from "react-intl";

const styles: { [key: string]: SxProps } = {
  accordionBox: {
    px: 0,
    py: 1,
  },
  accordion: {
    boxShadow: "none",
    textAlign: "left",
  },
  accordionSummary: {
    flexDirection: "row-reverse",
  },
  accordionDetails: {
    py: 0,
  },
};

const ErrorPage = () => {
  const telemetry = useTelemetry();
  const { formatMessage: t } = useIntl();

  const { url, message, error, operationId } = useStoreState(errorStore);

  useEffect(() => {
    if (error || message) {
      const errorObj = new Error(message || "Unknown orgportal error");
      telemetry.trackException(errorObj, {
        url,
        originalError: error,
        loggedFrom: "ErrorPage",
      });
    }
  }, [error, message, url, telemetry]);

  return (
    <Grid
      container
      display="flex"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      direction="column"
    >
      <Grid item xs={12} md={6}>
        <RoundedBox>
          <Typography variant="h4" gutterBottom>
            {t({ id: "sorryPageNotAvailable" })}
          </Typography>
          <Typography variant="body1">
            {t({ id: "tryAgainLater" })}
          </Typography>
        </RoundedBox>

        {(!!url || !!operationId) && (
          <RoundedBox sx={styles.accordionBox}>
            <Accordion sx={styles.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="details-content"
                id="details-header"
                sx={styles.accordionSummary}
              >
                <Typography variant="body1">{t({ id: "details" })}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={styles.accordionDetails}>
                {operationId && (
                  <Typography variant="body2">
                    {t({ id: "operationId" })}: {operationId}
                  </Typography>
                )}
                {url && <Typography variant="body2">{t({ id: "url" })}: {url}</Typography>}
              </AccordionDetails>
            </Accordion>
          </RoundedBox>
        )}
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
